import 'core-js/stable'
import Vue from 'vue'
import App from './App'
import router from './router'
import CoreuiVue from '@coreui/vue'
import {iconsSet as icons} from './assets/icons/icons.js'
import store from './store'
import {ApiPlugin} from './plugins/api'

Vue.config.performance = true
Vue.use(CoreuiVue)
Vue.prototype.$log = console.log.bind(console)

Vue.use(ApiPlugin)

const api = Vue.prototype.$api
const token = api.token
if (token) {
  fetch('/api/editor/bootstrap')
    .then(response => response.json())
    .then(settings => {
      Vue.prototype.$settings = settings
      new Vue({
        el: '#app',
        router,
        store,
        icons,
        template: '<App/>',
        components: {
          App
        }
      })
    })
}
